import { useCallback, useState } from "react";

export function useSceneGraphTooltip() {
  const [sceneGraphTooltip, setSceneGraphTooltip] = useState(null);

  const showSceneGraphTooltip = useCallback((event, content) => {
    const bounds = event.currentTarget?.getBoundingClientRect?.();
    const left =
      typeof event.clientX === "number" ? event.clientX : bounds?.left + bounds?.width / 2;
    const top = typeof event.clientY === "number" ? event.clientY : bounds?.top;
    setSceneGraphTooltip({ content, left: left ?? 0, top: (top ?? 0) - 8 });
  }, []);

  const hideSceneGraphTooltip = useCallback(() => {
    setSceneGraphTooltip(null);
  }, []);

  return { sceneGraphTooltip, showSceneGraphTooltip, hideSceneGraphTooltip };
}
